// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-page-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  min-height: 78px;
  padding: 16px 18px 16px;
  border-top: 1px solid #eef2f7;
  background: #ffffff;
  color: #64748b;
  font-size: 14px;
  position: relative;
  z-index: 1;
}

.table-page-pagination__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.table-page-pagination__label--editable input {
  width: 64px;
  height: 30px;
  border: 1px solid #d7e1ee;
  border-radius: 6px;
  background: #ffffff;
  color: #334155;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  text-align: center;
  padding: 0 8px;
  outline: none;
  appearance: textfield;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.table-page-pagination__label--editable input::-webkit-inner-spin-button,
.table-page-pagination__label--editable input::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.table-page-pagination__label--editable input:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.18);
}

.table-page-pagination__nav {
  display: inline-flex;
  gap: 8px;
}

.table-page-pagination__btn {
  width: 32px;
  height: 32px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #ffffff;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}

.table-page-pagination__btn:hover:not(:disabled) {
  background: #f8fafc;
}

@media (max-width: 768px) {
  .table-page-pagination {
    min-height: 0;
    padding: 14px 16px;
  }
}
.table-page-pagination__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/common/TablePagePagination/TablePagePagination.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,0DAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;EACA,+CAAA;AACF;;AAEA;EACE,oBAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,oFAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE;IACE,aAAA;IACA,kBAAA;EACF;AACF;AAEA;EACE,YAAA;EACA,mBAAA;AAAF","sourcesContent":[".table-page-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  min-height: 78px;\n  padding: 16px 18px 16px;\n  border-top: 1px solid #eef2f7;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 14px;\n  position: relative;\n  z-index: 1;\n}\n\n.table-page-pagination__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n}\n\n.table-page-pagination__label--editable input {\n  width: 64px;\n  height: 30px;\n  border: 1px solid #d7e1ee;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #334155;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 30px;\n  text-align: center;\n  padding: 0 8px;\n  outline: none;\n  appearance: textfield;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.table-page-pagination__label--editable input::-webkit-inner-spin-button,\n.table-page-pagination__label--editable input::-webkit-outer-spin-button {\n  appearance: none;\n  margin: 0;\n}\n\n.table-page-pagination__label--editable input:focus {\n  border-color: #94a3b8;\n  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.18);\n}\n\n.table-page-pagination__nav {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.table-page-pagination__btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #475569;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition: opacity 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\n}\n\n.table-page-pagination__btn:hover:not(:disabled) {\n  background: #f8fafc;\n}\n\n@media (max-width: 768px) {\n  .table-page-pagination {\n    min-height: 0;\n    padding: 14px 16px;\n  }\n}\n\n.table-page-pagination__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
